export const DELETE_PATH = 'DELETE_PATH';
